<template>
  <div>
    <div class="google-map" ref="googleMap"></div>
  </div>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader';
import { MarkerClusterer } from '@googlemaps/markerclusterer';

const GOOGLE_MAP_API_KEY = process.env.VUE_APP_API_GOOGLE_KEY;

export default {
  name: 'GoogleMapMarkers',
  props: {
    items: {
      type: Array,
    },
    isVisible: {
      type: Boolean,
    },
    maxZoom: {
      type: Number,
    },
    isCluster: {
      type: Boolean,
      default: false,
    },
    makeTitle: {
      type: Function,
      default: (item) => `${item.id}. ${item.name}`,
    },
    makeInfoWindowContent: {
      type: Function,
      default: (item) => `${item.id}. ${item.name}`,
    },
  },
  data() {
    return {
      map: null,
      google: null,
      loader: null,
      infoWindow: null,
      markers: [],
      markerClusterer: null,
      options: {
        center: {
          lat: 0,
          lng: 0,
        },
        zoom: 3,
        mapId: 'MAP_ID_MARKER',
      },
      bounds: {},
    };
  },
  mounted() {
    this.loader = new Loader({
      apiKey: GOOGLE_MAP_API_KEY,
      version: 'weekly',
      libraries: ['places', 'marker'],
    });
    this.initializeMap();
  },
  methods: {
    initializeMap() {
      const mapContainer = this.$refs.googleMap;

      // set random  mapId
      this.options.mapId = `MAP_ID_MARKER_${Date.now()}`;

      this.loader
        .load()
        .then((google) => {
          this.google = google;
          this.map = new google.maps.Map(mapContainer, this.options);
          this.infoWindow = new google.maps.InfoWindow();

          if (this.isCluster) {
            this.markerClusterer = new MarkerClusterer({ map: this.map });
          }
          this.updateMarkersOnMap(this.items);
        })
        .catch(() => {
          console.log('Google maps error');
        });
    },

    setMarkers(items) {
      const bounds = new this.google.maps.LatLngBounds();

      if (this.markers.length > 0) {
        this.setMapOnAll(null);
        this.markers = [];
      }
      items.forEach((el) => {
        if (el.lat === null || el.lon === null) {
          return;
        }
        const marker = new this.google.maps.marker.AdvancedMarkerElement({
          position: {
            lat: el.lat,
            lng: el.lon,
          },
          title: this.makeTitle(el),
        });

        marker.addListener('click', () => {
          this.infoWindow.close();
          this.infoWindow.setContent(this.makeInfoWindowContent(el));
          this.infoWindow.open(marker.map, marker);
        });
        bounds.extend(marker.position);
        this.markers.push(marker);
      });
      this.map.fitBounds(bounds);

      if (this.maxZoom) {
        setTimeout(() => {
          const zoom = this.map.getZoom();
          if (zoom > this.maxZoom) {
            this.map.setZoom(this.maxZoom);
          }
        }, 500);
      }
    },

    setMapOnAll(map) {
      for (let i = 0; i < this.markers.length; i += 1) {
        this.markers[i].setMap(map);
      }
    },

    updateMarkersOnMap(val) {
      this.setMarkers(val);
      this.setMapOnAll(this.map);

      if (this.isCluster) {
        this.markerClusterer.clearMarkers();
        this.markerClusterer.addMarkers(this.markers);
      }
    },
  },
  watch: {
    isVisible(val) {
      if (val) {
        this.updateMarkersOnMap(this.items);
      }
    },
    items(val) {
      this.updateMarkersOnMap(val);
    },
  },
};
</script>

<style scoped>
.google-map {
  width: 100%;
  min-height: 400px;
  height: 500px;
}
</style>
